import Tracker from '@nio-fe/nio-tracker-web'
import { useAppStore } from '../stores/app'
import { isInApp } from '@nio-wad/hooks'
import { nioJsBridge } from '@nio-wad/universal-bridge-h5'

/**
 * App内打开页面
 * @param {string} url 跳转url，支持http和schema
 * @returns {undefined} undefined
 */
export const openInApp = (url: string, name?: string) => {
  if (name) {
    const appStore = useAppStore() // 全局store
    Tracker.track(`nsh5m_${name}`, appStore.trackParamsCommon)
  }
  url &&
    nioJsBridge.openURL({
      data: {
        url,
      },
    })
}

// 链接跳转和点击埋点
export const openLink = (url: string, name: string) => {
  const appStore = useAppStore() // 全局store
  // 链接跳转埋点
  Tracker.track(`nsh5m_${name}`, appStore.trackParamsCommon)
  isInApp
    ? url &&
      nioJsBridge.openURL({
        data: {
          url,
        },
      })
    : url && (window.location.href = url)
}

const UA = navigator.userAgent // 获取UA
const ua = navigator.userAgent.toLowerCase() // 获取ua

/**
 * 当前环境是否为微信
 */
export const isWX = /(?:MicroMessenger)/.test(UA)

type OpenParams<T extends (...args: any) => any> = T extends (...args: [any, ...infer P]) => any
  ? P
  : never
export const openUrl = (
  url: string,
  openType = 'navigateTo',
  ...params: OpenParams<typeof window.open>
) => {
  if (isInApp) {
    switch (openType) {
      case 'navigateTo':
        nioJsBridge.openURL({
          data: {
            url,
          },
        })
        break
      case 'redirectTo':
        nioJsBridge.replace({
          data: {
            url,
          },
        })
        break
    }
  } else {
    window.location.href = url
  }
}

/**
 * 判断是否是小程序
 * @returns
 */
export const isInMiniProgram = () => {
  const ua = navigator.userAgent
  return /miniprogram/i.test(ua) // 小程序环境中，userAgent通常包含miniprogram关键字
}

export const initWeChatSDK = () => {
  if (typeof wx !== 'undefined') return Promise.resolve()

  let promiseResolver: (value: unknown) => void
  const promise = new Promise((resolve) => {
    promiseResolver = resolve
  })
  const script = document.createElement('script')
  script.src = 'https://res.wx.qq.com/open/js/jweixin-1.6.0.js'
  script.onload = () => {
    promiseResolver && promiseResolver(undefined)
  }
  document.head.appendChild(script)

  return promise
}

/**
 * https 链接跳转
 * 1. 在微信浏览器，https 链接跳转
 * 2. 在微信小程序中打开 https 链接
 * 以modules开头的跳转
 * 3. 在微信小程序中打开 以modules开头的跳转小程序页面路径
 * app scheme 跳转
 * @param link
 * @param openType  navigateTo
 * @returns
 */
export async function handleUrlLink(link: string, openType = 'navigateTo') {
  if (!link) return
  console.log('====================================')
  console.log('handleUrlLink', link)
  console.log('====================================')
  const urlReg =
    /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()!@:%_\+.~#?&\/\/=]*)/ // eslint-disable-line
  if (urlReg.test(link)) {
    console.log('====================================')
    console.log(navigator.userAgent, isWX, isInMiniProgram())
    console.log('====================================')
    // https 链接跳转
    if (isInMiniProgram()) {
      // 微信小程序中打开 https 链接
      await initWeChatSDK()
      wx.miniProgram.navigateTo({
        url: `/modules/universal/pages/universal-bridge-webview/index?url=${encodeURIComponent(
          link
        )}`,
      })
    } else {
      // 1. 在微信浏览器，https 链接跳转
      // 浏览器 直接打开链接
      openUrl(link, openType)
    }
  } else if (isInMiniProgram()) {
    // 以modules开头的跳转小程序页面路径
    await initWeChatSDK()
    switch (openType) {
      case 'navigateTo':
        wx.miniProgram.navigateTo({
          url: link,
        })
        break
      case 'redirectTo':
        wx.miniProgram.redirectTo({
          url: link,
        })
        break
      case 'switchTab':
        wx.miniProgram.switchTab({
          url: link,
        })
        break

      default:
        wx.miniProgram.navigateTo({
          url: link,
        })
        break
    }
  } else {
    // app scheme 跳转
    openUrl(link, openType)
  }
}
